import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { breezeLibraryInitProvider } from './breeze-library-init.provider';
import { BreezePropertyConfig, defaultBreezePropertyConfig } from './breeze-property-config';
import { BREEZE_ENTITY_REGISTRATION_FUNC, BREEZE_METADATA_TOKEN, BreezeEntityRegistryFunc } from './injection-tokens';
import { metadataStoreProvider } from './metadata-store.provider';
import { UnitOfWorkRouteReuseStrategy } from './unit-of-work-route-reuse-strategy';
import { registerValidators } from './validators/register-validators';

export interface BreezeEntityModuleConfig {
  metadata?: object;
  entityRegistration?: BreezeEntityRegistryFunc;
  propertyOptions?: Partial<BreezePropertyConfig>;
}

export function provideBreeze(config: BreezeEntityModuleConfig = {}): EnvironmentProviders {
  const breezePropertyOptions: BreezePropertyConfig = {
    ...defaultBreezePropertyConfig,
    ...config.propertyOptions
  };
  return makeEnvironmentProviders([
    breezeLibraryInitProvider,
    metadataStoreProvider,
    { provide: RouteReuseStrategy, useClass: UnitOfWorkRouteReuseStrategy },
    { provide: BreezePropertyConfig, useValue: breezePropertyOptions },
    config.metadata ? { provide: BREEZE_METADATA_TOKEN, useValue: config.metadata } : [],
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: registerValidators, multi: true },
    config.entityRegistration
      ? { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: config.entityRegistration, multi: true }
      : []
  ]);
}
